export default __webpack_public_path__ + "static/media/slider-info-right-light-3.1c5c48ec.png";